<template>
  <v-container>
    <v-layout justify-center>
      <v-flex xs12>
        <v-card>
          <l-data-table
          :headers="header"
          :get-data-func="getVisitorList"
          hide-refresh
          ref="visitorList" title-text="批量导入车辆管理列表">
            <template slot="title-search">
              <v-layout>
                <v-text-field v-model="carSearch" placeholder="请输入车牌号进行搜索"></v-text-field>
                <v-btn icon @click="refreshList">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </v-layout>
            </template>
            <template slot="row-action" slot-scope="{item}">
              <td @click.stop class="px-0 mx-0 text-xs-center">
                <l-option-menu
                  :options="moreActions"
                  @edit="editVehicle(item)"
                  @delete="deleteVehicle(item)"
                >
                  <v-btn icon slot="activator">
                    <v-icon>$vuetify.icons.more</v-icon>
                  </v-btn>
                </l-option-menu>
              </td>
            </template>
          </l-data-table>
        </v-card>
        <v-dialog
          v-model="visitorDialog"
          width="800"
          persistent>
          <v-layout column>
            <v-card>
              <v-card-title class="primary white--text">
                <span v-if="status==='add'" style="font-size: 16px">新增访客</span>
                <span v-else style="font-size: 16px">访客编辑</span>
                <v-spacer></v-spacer>
                <v-btn icon @click="visitorDialog=false">
                  <v-icon>$vuetify.icons.close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-form ref="visitorForm">
                  <l-plate-picker
                    v-model="visitorForm.visitorVeCode"></l-plate-picker>
                  <v-text-field
                    label="访客手机"
                    v-model="visitorForm.visitorPhone"
                    prepend-icon="mdi-phone"
                    :rules="$rules.phone11()"
                  ></v-text-field>
                  <v-text-field
                    label="访客姓名"
                    v-model="visitorForm.visitorName"
                    prepend-icon="mdi-account"
                  ></v-text-field>
                  <v-text-field
                    label="访客单位"
                    prepend-icon="mdi-account-group"
                    v-model="visitorForm.visitorOrg"
                  ></v-text-field>
                  <v-select
                    label="证件类型"
                    v-model="visitorForm.visitorIdType"
                    :items="visitorTypeSelect"
                    item-text="text"
                    item-value="text"
                    prepend-icon="mdi-account-box"
                  ></v-select>
                  <v-text-field
                    label="证件号码"
                    :disabled="visitorForm.visitorIdType===''"
                    prepend-icon="mdi-account-card-details"
                    v-model="visitorForm.visitorIdNum"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-layout justify-center>
                  <v-btn class="info" @click="(status==='add')?addSave():editSave()">确认</v-btn>
                  <v-btn class="error" @click="visitorDialog=false">取消</v-btn>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-layout>
        </v-dialog>
      </v-flex>
      <l-fixed-btn
        @click="addVehicle()"
        icon="$vuetify.icons.add"
      ></l-fixed-btn>
    </v-layout>
    <!--<v-layout class="my-5" justify-center>
      <v-progress-circular color="primary" indeterminate size="60"></v-progress-circular>
    </v-layout>-->
  </v-container>
</template>
<script>
import LDataTable from '../../../ladmin/components/LDataTable/LDataTable'
import LPlatePicker from '../../../components/LPlatePicker'
export default {
  name: 'visitorList',
  components: {LDataTable, LPlatePicker},
  props: {
  },
  data () {
    return {
      header: [
        {text: '访客车牌', align: 'left', value: 'visitorVeCode'},
        {text: '访客手机', align: 'left', value: 'visitorPhone'},
        {text: '访客姓名', align: 'left', value: 'visitorName'},
        {text: '访客单位', align: 'left', value: 'visitorOrg'},
        {text: '证件号码', align: 'left', value: 'visitorIdNum'},
        {text: '证件类型', align: 'left', value: 'visitorIdType'},
      ],
      visitorForm: {
        visitorVeCode: '',
        visitorPhone: '',
        visitorName: '',
        visitorOrg: '',
        visitorIdNum: '',
        visitorIdType: ''
      },
      visitorTypeSelect: [
        {
          text: '居民身份证',
          value: 'idCard'
        },
        {
          text: '军官证|警官证|士兵证',
          value: 'osCard'
        },
        {
          text: '护照',
          value: 'passport'
        },
        {
          text: '港澳|台湾居民来往内地通行证',
          value: 'mtPermit'
        }
      ],
      moreActions: [
        {
          event: 'edit',
          label: '编辑',
          icon: ''
        },
        {
          event: 'delete',
          label: '删除',
          icon: ''
        },
      ],
      status: 'add',
      // 车辆详细信息
      detailsDialog: {
        activate: false,
        item: {}
      },
      visitorDialog: false,
      loading: false,
      curVisitor: {},
      carSearch: ''
    }
  },
  created () {
  },
  methods: {
    async getVisitorList ({pagination, sortStack, filterItems, search}) {
      if (this.carSearch !== '') {
        return this.searchCar()
      }
      this.loading = true
      let res = await this.$store.dispatch('letterReservation/getVisitorList', {pagination: pagination, procInstId: this.$route.query.id})
      this.loading = false
      if (res.data.code + '' === '200') {
        return {items: res.data.data.dataDetails, amount: res.data.data.dataDetails.length}
      }
      else {
        this.$L.alert('error', {message: '查询访客车辆列表信息错误，原因：' + res.data.msg})
      }
    },
    editVehicle (item) {
      this.status = 'edit'
      this.visitorDialog = true
      this.curVisitor = item
      this.visitorForm.visitorVeCode = item.visitorVeCode
      this.visitorForm.visitorPhone = item.visitorPhone
      this.visitorForm.visitorIdNum = item.visitorIdNum
      this.visitorForm.visitorIdType = item.visitorIdType
      this.visitorForm.visitorOrg = item.visitorOrg
      this.visitorForm.visitorName = item.visitorName
    },
    async editSave () {
      if (this.$refs.visitorForm.validate()) {
        let config = {
          'formKey': 'spava_pass-control_form_act-cfg',
          'procInstId': this.$route.query.id,
          'updateVelInFormList': [
            {
              'originVel': this.curVisitor.visitorVeCode,
              'updatedVel': this.visitorForm.visitorVeCode,
              'updatedPhone': this.visitorForm.visitorPhone,
              'updatedCampus': this.visitorForm.visitorOrg,
              'updatedName': this.visitorForm.visitorName,
              'updateIdNum': this.visitorForm.visitorIdNum,
              'updateIdType': this.visitorForm.visitorIdType
            }
          ]
        }
        let res = await this.$store.dispatch('letterReservation/editVisitor', config)
        if (res.data.code + '' === '200') {
          this.$L.alert('success', {message: '保存编辑成功'})
          this.visitorDialog = false
          this.$refs.visitorList.refresh()
        }
        else {
          this.$L.alert('error', {message: '保存失败,原因:' + res.data.msg})
          this.visitorDialog = false
        }
      }
      else {
        this.$L.alert('error', {message: '表单数据不合法'})
      }
    },
    async deleteVehicle (item) {
      let obj = {
        'formKey': 'spava_pass-control_form_act-cfg',
        'procInstId': this.$route.query.id,
        'velInFormList': [
          item.visitorVeCode.toString()
        ]
      }
      let res = await this.$store.dispatch('letterReservation/deleteVisitor', obj)
      if (res.data.code + '' === '200') {
        this.$L.alert('success', {message: '删除成功'})
        this.$refs.visitorList.refresh()
      }
      else {
        this.$L.alert('error', {message: '删除失败，原因:' + res.data.msg})
      }
    },
    async addSave () {
      if (this.$refs.visitorForm.validate()) {
        let config = {
          'formKey': 'spava_pass-control_form_act-cfg',
          'procInstId': this.$route.query.id,
          'updateVelInFormList': [
            {
              'updatedVel': this.visitorForm.visitorVeCode,
              'updatedPhone': this.visitorForm.visitorPhone,
              'updatedCampus': this.visitorForm.visitorOrg,
              'updatedName': this.visitorForm.visitorName,
              'updateIdNum': this.visitorForm.visitorIdNum,
              'updateIdType': this.visitorForm.visitorIdType
            }
          ]
        }
        let res = await this.$store.dispatch('letterReservation/addVisitor', config)
        if (res.data.code + '' === '200') {
          this.$L.alert('success', {message: '添加成功'})
          this.$refs.visitorList.refresh()
          this.visitorDialog = false
        }
        else {
          this.$L.alert('error', {message: '添加失败,原因:' + res.data.msg})
          this.visitorDialog = false
        }
      }
      else {
        this.$L.alert('error', {message: '表单数据不合法'})
      }
    },
    addVehicle () {
      this.status = 'add'
      this.visitorDialog = true
      this.curVisitor = {}
      this.visitorForm.visitorVeCode = ''
      this.visitorForm.visitorPhone = ''
      this.visitorForm.visitorIdNum = ''
      this.visitorForm.visitorIdType = ''
      this.visitorForm.visitorOrg = ''
      this.visitorForm.visitorName = ''
    },
    async searchCar () {
      let config = {
        "formKey":"spava_pass-control_form_act-cfg",
        "procInstId":this.$route.query.id,
        "velInForm":this.carSearch
      }
      let res = await this.$store.dispatch('letterReservation/searchVisitor',config)
      if(res.data.code+''==='200'){
        let list = []
        list.push(res.data.data)
        return {items:list,amount:list.length}
      }else{
        this.$L.alert('error',{message:res.data.msg})
      }
    },
    refreshList () {
      this.$refs.visitorList.refresh()
    }
  },
}
</script>
